import { render, staticRenderFns } from "./ManagerInfo.vue?vue&type=template&id=494aa026"
import script from "./ManagerInfo.vue?vue&type=script&lang=js"
export * from "./ManagerInfo.vue?vue&type=script&lang=js"
import style0 from "./ManagerInfo.vue?vue&type=style&index=0&id=494aa026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports